import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c4afb2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "draft" }
const _hoisted_2 = { class: "topbar-wrap" }
const _hoisted_3 = { class: "topbar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "vueDraft", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/FeatheredSnek/vue-draft",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi-github hoverable" })
], -1))
const _hoisted_6 = {
  key: 0,
  class: "re-start"
}
const _hoisted_7 = {
  key: 1,
  class: "deal"
}
const _hoisted_8 = { class: "counter" }
const _hoisted_9 = { class: "cards" }
const _hoisted_10 = {
  key: 2,
  class: "re-start"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Your deck is ready", -1))

import CardPreview from "@/components/CardPreview.vue"
  import { computed, reactive, ref } from "vue"
  import { Card } from "@/types/index"

  
export default /*#__PURE__*/_defineComponent({
  props: {
    deal: null,
    round: null,
    totalRounds: null
  },
  emits: ["pick", "restart", "start"],
  setup(__props: any, { emit }: { emit: ({
    (e: "pick", value: Card): void
    (e: "restart"): void
    (e: "start"): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    deal: Card[]
    round: number
    totalRounds: number
  }

  

  const roundCounter = computed(() => {
    if (props.round === 0) return "Waiting for draft"
    if (props.round > props.totalRounds) return "Draft finished"
    return `Draft round ${props.round} of ${props.totalRounds}`
  })

  const startButtonStatus = computed(() => {
    return props.round === 0 ? "hoverable" : ""
  })

  const restartButtonStatus = computed(() => {
    return props.round > 0 ? "hoverable" : ""
  })

  const movementClasses = reactive([
    "movement-default",
    "movement-default",
    "movement-default",
  ])

  const pickable = ref(true)

  function pickHandler(pickedCard: Card, pickedIndex: number) {
    // handle clicks only when the card animation is finished
    if (pickable.value === true) {
      pickable.value = false
      // 1) move->hide 2) change data 3) hide->appear
      // with 50ms delay between transition steps to avoid glitches
      movementClasses.fill("movement-down")
      movementClasses[pickedIndex] = "movement-side"
      setTimeout(() => {
        movementClasses.fill("movement-hidden")
      }, 550)
      setTimeout(() => {
        emit("pick", pickedCard)
      }, 600)
      setTimeout(() => {
        movementClasses.fill("movement-default")
      }, 650)
      setTimeout(() => {
        pickable.value = true
      }, 1150)
    }
  }

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("i", {
          class: _normalizeClass(["bi-play-circle-fill", _unref(startButtonStatus)]),
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('start')), ["prevent"]))
        }, null, 2),
        _createElementVNode("i", {
          class: _normalizeClass(["bi-skip-backward-circle-fill", _unref(restartButtonStatus)]),
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('restart')), ["prevent"]))
        }, null, 2),
        _hoisted_5
      ])
    ]),
    _createVNode(_Transition, {
      name: "modal",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (props.round === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("p", null, "Begin drafting " + _toDisplayString(__props.totalRounds) + " cards", 1),
              _createElementVNode("p", null, [
                _createElementVNode("i", {
                  class: _normalizeClass(["bi-play-circle-fill", _unref(startButtonStatus)]),
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('start')), ["prevent"]))
                }, null, 2)
              ])
            ]))
          : (props.round <= props.totalRounds)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(roundCounter)), 1),
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.deal, (card) => {
                    return (_openBlock(), _createBlock(CardPreview, {
                      key: card.id,
                      card: card,
                      "movement-class": _unref(movementClasses)[__props.deal.indexOf(card)],
                      onClick: ($event: any) => (pickHandler(card, __props.deal.indexOf(card)))
                    }, null, 8, ["card", "movement-class", "onClick"]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("p", null, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["bi-skip-backward-circle-fill", _unref(restartButtonStatus)]),
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('restart')), ["prevent"]))
                  }, null, 2)
                ])
              ]))
      ]),
      _: 1
    })
  ]))
}
}

})